<template>
  <!-- 节点测试：专注执行并查看单个 Job 的请求/响应/断言结果。 -->
  <section class="view nodes-view">
    <div class="split-grid compact">
      <section class="surface">
        <div class="surface-head">
          <div>
            <h2>节点测试</h2>
            <span>{{ selectedJob ? `节点 #${selectedJob.id}` : '未选择节点' }}</span>
          </div>
        </div>

        <div class="node-controls">
          <el-select
            :model-value="nodeJobId"
            clearable
            filterable
            placeholder="选择节点"
            @update:model-value="selectNodeJob"
          >
            <el-option
              v-for="job in jobs"
              :key="job.id"
              :label="jobOptionLabel(job)"
              :value="String(job.id)"
            />
          </el-select>
          <el-button
            type="primary"
            :icon="icons.VideoPlay"
            :disabled="!nodeJobId"
            :loading="runningJobId === Number(nodeJobId)"
            @click="runSelectedNode"
          >
            节点测试
          </el-button>
        </div>

        <el-descriptions v-if="selectedJob" :column="1" border class="node-detail">
          <el-descriptions-item label="Step">{{ selectedJob.step }}</el-descriptions-item>
          <el-descriptions-item v-if="selectedJob.step_desc" label="描述">
            {{ selectedJob.step_desc }}
          </el-descriptions-item>
          <el-descriptions-item label="请求方式">
            <el-tag :type="methodTagType(selectedJob.http_type)">
              {{ selectedJob.http_type || 'GET' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="断言策略">
            {{ blockLabel(selectedJob) }}
          </el-descriptions-item>
          <el-descriptions-item label="URL">
            <span class="url-text">{{ selectedJob.url || '-' }}</span>
          </el-descriptions-item>
        </el-descriptions>
        <el-empty v-else description="请选择节点" />
      </section>

      <section class="surface">
        <div class="surface-head">
          <div>
            <h2>节点测试结果</h2>
            <span v-if="selectedJob">节点 #{{ selectedJob.id }}</span>
            <span v-else>暂无选择</span>
          </div>
          <div v-if="currentAssertion" class="assertion-actions">
            <el-tag :type="currentAssertion.ok ? 'success' : 'danger'">
              {{ currentAssertion.ok ? '断言通过' : '断言失败' }}
            </el-tag>
            <el-button
              v-if="currentAssertionFailures.length"
              size="small"
              type="danger"
              plain
              @click="openAssertionDialog"
            >
              查看原因
            </el-button>
          </div>
        </div>
        <div class="result-grid">
          <section class="result-panel">
            <h3>请求参数</h3>
            <pre class="response-box tall">{{ currentRequestText || '暂无请求参数' }}</pre>
          </section>
          <section class="result-panel">
            <h3>响应体</h3>
            <pre class="response-box tall">{{ currentResponseBodyText || '暂无响应体' }}</pre>
          </section>
        </div>
        <section v-if="currentAssertionFailures.length" class="assertion-failures">
          <h3>断言失败明细</h3>
          <ul class="assertion-failure-list">
            <li v-for="reason in currentAssertionFailures" :key="reason">{{ reason }}</li>
          </ul>
        </section>
      </section>
    </div>

    <el-dialog
      v-model="assertionDialogVisible"
      title="断言失败原因"
      width="640px"
      class="assertion-dialog"
    >
      <ul class="assertion-dialog-list">
        <li v-for="reason in currentAssertionFailures" :key="reason">{{ reason }}</li>
      </ul>
      <template #footer>
        <el-button @click="assertionDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { VideoPlay } from "@element-plus/icons-vue";
import { blockLabel, jobOptionLabel, methodTagType } from "../utils/job-display";
import {
  assertionFailureReasons,
  formatRequestParams,
  formatResponseBody,
} from "../utils/result-format";

export default {
  name: "NodesPage",

  data() {
    return {
      icons: {
        VideoPlay,
      },
      assertionDialogVisible: false,
    };
  },

  computed: {
    ...mapState(["jobs", "selectedJob", "nodeJobId", "runningJobId"]),
    ...mapGetters(["currentResult", "currentAssertion"]),

    currentRequestText() {
      return formatRequestParams(this.currentResult);
    },

    currentResponseBodyText() {
      return formatResponseBody(this.currentResult);
    },

    currentAssertionFailures() {
      return assertionFailureReasons(this.currentAssertion);
    },
  },

  methods: {
    ...mapActions(["selectNodeJob", "runSelectedNode"]),
    blockLabel,
    jobOptionLabel,
    methodTagType,

    openAssertionDialog() {
      if (this.currentAssertionFailures.length) {
        this.assertionDialogVisible = true;
      }
    },
  },
};
</script>
